import{sizes as e}from"../text/text.types";const i={orange:"orange"},r={defualt:"default",fixed:"fixed"},a={interface:e.interface,small:e.small,basic:e.basic,large:e.large},n={prefix:"prefix",suffix:"suffix"};export{r as backgrounds,n as iconPositions,a as sizes,i as variants};
//# sourceMappingURL=link.types.js.map
